import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    getAbcRequest,
    getAverageCheckByDaylRequest,
    getCountChecksByDaylRequest,
    getInventedItemsRequest,
    getLike4LikeRequest,
    getRestRevenueByDaylRequest,
    getSourcesRequest,
    getStopPositionRequest,
    getTopPositionRequest,
} from '@api/services/reportsApi';
import { axiosErrorHandler } from '@api/config';
import { IRestTotalReq } from '@api/services/rKeeperApi/types';
import {
    ILike4Like,
    IReportAbc,
    IReportAverageCheckByDay,
    IReportCountChecksByDay,
    IReportRestByDay,
    ISourcesData,
    TransformTopResult,
} from '@entities/reports';
import { transformTopPositions } from '@utils/functions/transformTopPosition';
import { IDateRangeType } from '@types';

export const getRevenueRestaurantsByDay = createAsyncThunk<
    IReportRestByDay,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/getRevenueRestaurantsByDay',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getRestRevenueByDaylRequest(shop_id, params);

            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getCountChecksByDay = createAsyncThunk<
    IReportCountChecksByDay,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/getCountChecksByDay',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getCountChecksByDaylRequest(shop_id, params);

            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
export const getAverageCheckByDay = createAsyncThunk<
    IReportAverageCheckByDay,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/getAverageCheckByDay',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getAverageCheckByDaylRequest(
                shop_id,
                params
            );

            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getTopPositions = createAsyncThunk<
    TransformTopResult,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/getTopPositions',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data: items } = await getInventedItemsRequest(shop_id);
            const { data } = await getTopPositionRequest(shop_id, params);
            return transformTopPositions(items, data, shop_id);
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
export const getStopPositions = createAsyncThunk<
    TransformTopResult,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/getStopPositions',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data: items } = await getInventedItemsRequest(shop_id);
            const { data } = await getStopPositionRequest(shop_id, params);
            return transformTopPositions(items, data, shop_id);
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getLike4Like = createAsyncThunk<
    ILike4Like,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/getLike4Like',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getLike4LikeRequest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const geReportAbc = createAsyncThunk<
    IReportAbc,
    { shop_id: number; params: IRestTotalReq }
>(
    '@@rKeeper/geReportAbc',
    async (
        { shop_id, params }: { shop_id: number; params: IRestTotalReq },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getAbcRequest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getSources = createAsyncThunk<
    ISourcesData,
    { shop_id: number; params: IDateRangeType }
>(
    '@@reports/geSources',
    async (
        { shop_id, params }: { shop_id: number; params: IDateRangeType },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getSourcesRequest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
